import { TRANSLOCO_SCOPE } from "../constants/i18n.constants";
import { i18nLoader } from "../services/i18n.loader";
import { provideTranslocoScope } from "@jsverse/transloco";

/**
 * Provides a Transloco scope configuration specific to the "auth" module.
 *
 * This function defines the scope for translations within the "auth" module.
 * It associates the provided scope (`TRANSLOCO_SCOPE`) with the custom loader
 * for loading translation files dynamically. This setup ensures that translation
 * files are properly scoped and lazy-loaded when needed.
 *
 * @returns {object} Configuration object for the Transloco scope.
 */
export const provideAuthTranslocoScope = () =>
  provideTranslocoScope({
    scope: TRANSLOCO_SCOPE, // Translation scope for the "auth" module
    loader: i18nLoader, // Custom loader for fetching "auth" translations
  });

